module.exports = __webpack_public_path__ + "static/media/audio-08-tt.352f6922.mp3";